import * as React from 'react';
import { Component } from '../../lib/component';
import { getAmountValues } from '../../lib/helpers';
import { FormattedMessage } from 'react-intl';
import { betweenJustified, horizontal, vertical, verticallySpaced } from 'csstips';
import { style } from 'typestyle';
import {ButtonPill} from '../button-pill';
import {mediaTablet, mediaMobileOnly} from '../../theme/media';
import {ChannelSchema, OrderSchema} from '../../types/schema';
import {formatCurrency} from '../../lib/currency';
import {percent, px, rem} from 'csx';
import {colorSubtle} from '../../theme/color';

export interface AccountOrderDetailsProps {
  order: OrderSchema;
  channels: Array<ChannelSchema>;
}

export class AccountOrderDetails extends Component<AccountOrderDetailsProps> {
  render() {
    const { channels } = this.props;
    const amount = getAmountValues(this.props.order.amount);
    const { currency } = this.props.order.locale;

    return (
      <div className={AccountOrderDetails.styles.container}>
        <ul className={AccountOrderDetails.styles.innerContainer}>
          {channels && (
            <li>
              <FormattedMessage tagName="div" id="account.order.details.channels.title" />
              <div>
                {channels.map((channel, index) => (
                  <a className={AccountOrderDetails.styles.channelLink} href={`https://www.youtube.com/channel/${channel.id}`} key={index.toString()}>{channel.name}</a>
                ))}
              </div>
            </li>
          )}
          {amount.discount > 0 && (
            <li>
              <FormattedMessage tagName="div" id="account.order.details.discount.title" />
              <FormattedMessage tagName="div" id="account.order.details.discount.value" values={{
                value: formatCurrency(amount.discount, currency)
              }} />
            </li>
          )}
          {amount.vat > 0 && (
            <li>
              <FormattedMessage tagName="div" id="account.order.details.vat.title" />
              <FormattedMessage tagName="div" id="account.order.details.vat.value" values={{
                value: formatCurrency(amount.vat, currency)
              }} />
            </li>
          )}
          {amount.card_fee > 0 && (
            <li>
              <FormattedMessage tagName="div" id="account.order.details.card_fee.title" />
              <FormattedMessage tagName="div" id="account.order.details.card_fee.value" values={{
                value: formatCurrency(amount.card_fee, currency)
              }} />
            </li>
          )}
          <li>
            <FormattedMessage tagName="div" id="account.order.details.total.title" />
            <FormattedMessage tagName="div" id="account.order.details.total.value" values={{
              value: formatCurrency(amount.total, currency)
            }} />
          </li>
        </ul>
      </div>
    )
  }

  static styles = {
    container: style(
      mediaMobileOnly({
        ...vertical,
        ...verticallySpaced(20),
      }),
      mediaTablet({
        ...horizontal,
        ...betweenJustified
      })
    ),
    channelLink: style({ display: 'block' }),
    innerContainer: style(
      {
        margin: 0,
        padding: 0,
        listStyle: 'none inside none',
        $nest: {
          '& li': {
            minWidth: px(120),
            margin: 0,
            padding: '0 10px 0 0',
            display: 'inline-block',
          },
          '& li > div:first-child': {
            fontSize: rem(0.75),
            color: colorSubtle.toString(),
          }
        }
      },
      mediaMobileOnly({
        $nest: {
          '& li': {
            display: 'block',
            width: percent(100),
            margin: '0 0 10px 0',
          }
        }
      })
    )
  }
}